import React from 'react';

import { createIcon } from '../createIcon';

function SvgAlertCircle(props: React.SVGProps<SVGSVGElement>): React.JSX.Element {
  return (
    <svg width="1em" height="1em" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M8 2c3.321 0 6 2.679 6 6s-2.679 6-6 6a5.99 5.99 0 01-6-6c0-3.321 2.679-6 6-6zm0 1.286A4.68 4.68 0 003.286 8 4.68 4.68 0 008 12.714 4.68 4.68 0 0012.714 8 4.68 4.68 0 008 3.286zm.42 1.43c.137.077.25.19.327.326l2.392 4.252a.857.857 0 01-.747 1.277H5.608a.857.857 0 01-.747-1.277l2.392-4.252a.857.857 0 011.167-.326zM8 6.714a.643.643 0 00-.637.556l-.006.087v1.286a.643.643 0 001.28.087l.006-.087V7.357A.643.643 0 008 6.714z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}

export const AlertCircleOutlinedIcon = createIcon(SvgAlertCircle, 'AlertCircleOutlinedIcon');
